module.exports = __webpack_public_path__ + "img/13.a4d330de.png";